<template>
    <div>
        <Header title="课程报名"></Header>
        <div class="header">
            <img :src="dataSources.cover" />
            <p>{{dataSources.name}}</p>
        </div>
        <div class="body">
            <courseDetailEnrollItem v-for="(item, index) in con_list" :key="index" :item="item" :index="index" :type="type" @callback="callback" />
        </div>
        <div class="footer" :class="{disabled: !selectIds.length}" @click="paySubmit" v-if="type == Constants.USER_STUDENT">
            立即报名
            <span v-if="total">（座位费合计{{total.toFixed(2)}}）</span>
        </div>
        <div class="footer" :class="{disabled: !selectIds.length}" @click="signUpSubmit" v-else>立即报名</div>
        <!-- popup -->
        <van-popup v-model="show">
            <div class="popup-window">
                <p>报名成功</p>
                <!-- <span>等待平台审核通过</span> -->
                <div @click="showPopup">确认</div>
            </div>
        </van-popup>
        <van-action-sheet v-model="showPaymentStyle" :actions="paymentActions" @select="_onSelectPayStyle" cancel-text="取消" close-on-click-action />
        <!-- 解锁课程 -->
        <van-dialog v-model="unlockShowDialog" title="解锁课程" :showConfirmButton="false" :showCancelButton="false">
            <div class="form-box">
                <div class="tips">
                    <span>咨询顾问：</span>
                    <span v-if="service&&service.customer_service">
                        {{service.customer_service.name}} {{service.customer_service.mobile}}
                    </span>
                    <span v-else>******</span>
                </div>
                <van-form @submit="onSubmit">
                    <van-field v-model="ticket_no" label="门票编号：" placeholder="请输入门票编号" :rules="[{ required: true, message: '请输入门票编号' }]" />
                    <van-field v-model="secret_key" label="兑换密钥：" placeholder="请输入兑换密钥" :rules="[{ required: true, message: '请输入兑换密钥' }]" />
                    <div class="btn-box">
                        <van-button type="info" size="small" color="#6472e8" plain @click="cancelDialog">取消</van-button>
                        <van-button type="info" size="small" color="linear-gradient(205deg,#9cb2f4 1%, #9bb1f4 1%, #6472e8 84%)" native-type="submit">提交核验</van-button>
                    </div>
                </van-form>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Lockr from 'lockr'
import courseDetailEnrollItem from '@/components/item/courseDetailEnrollItem'
import {
    payWayWeiXin,
    wxPay,
    aliPay
} from '@/utils/wxPay'
import { wxSetup, wxShare } from '@/utils/wxShare'
import { debounce } from '@/utils/tool'
import {
    mapGetters
} from "vuex";
export default {
    components: {
        Header,
        courseDetailEnrollItem,
    },
    computed: {
        ...mapGetters(["userInfo"]),
        ...mapGetters(["service"]),
    },
    data() {
        return {
            unlockShowDialog: false,
            active: 0,
            subject_id: "",
            dataSources: {},
            ticket_no: "",
            secret_key: "",
            type: "",
            stage_id: "",
            con_list: [],
            selectIds: [],
            return_path: 'mine',
            return_url: this.GLOBAL.H5_domain + '/#/mine',
            paymentActions: [{
                    name: '微信支付',
                    pay_type: payWayWeiXin()
                },
                {
                    name: '支付宝支付',
                    pay_type: 'alipay'
                },
            ],
            total: 0,
            pay_type: '',
            // 提示
            show: false,
            showPaymentStyle: false,
        };
    },
    created() {
        let {
            id,
            type
        } = this.$route.query
        this.stage_id = id
        this.type = type
        document.title = type == this.Constants.USER_STUDENT ? "报名课程" : "报名义工";
        this.requestData();
    },
    mounted() {
        setTimeout(() => {
            this._setupWechatConfig();
        }, 500);
    },
    updated() {},
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if (!url) return;
            window.location.href = url;
        },

        // 设置分享参数
        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            let _urlTemp = window.location.href;
            if (_urlTemp.indexOf('is_share=1&uid=') > -1) {
                _urlTemp = _urlTemp.split('is_share=1&uid=')[0] + 'is_share=1&uid=' + this.userInfo.id;
            } else {
                _urlTemp = _urlTemp + '&is_share=1&uid=' + this.userInfo.id;
            }

            console.log('this.userInfo, _urlTemp---->', this.userInfo, _urlTemp);

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                let share_params = {
                    ...result.data.share_params,
                    title: this.dataSources.name,
                    desc: this.dataSources.desc,
                    icon: this.dataSources.cover,
                    link: _urlTemp,
                }
                wxShare(result.data.share_config, share_params, () => {});
            }
        },

        // 请求数据
        async requestData() {
            let url = this.API.enroll_index;
            let params = {
                stage_id: this.stage_id,
                type: this.type,
                // type: "student",
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let {
                    con_list,
                    ...data
                } = result.data
                this.dataSources = data
                this.con_list = con_list.map(item => {
                    item.selected = false
                    item.radio = 0
                    return item
                })
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        // callback
        callback(index) {
            let item = this.con_list[index];
            console.log('item---->', item);

            let {
                sign_status
            } = item;
            if (sign_status.status < 0 && item.subject_id == 1) {
                return this.requestData();
                // return this.requestCourseData(item.subject_id);
            }

            if (this.type == this.Constants.USER_STUDENT) {
                if (sign_status.status === 0) {
                    this.con_list[index].selected = !this.con_list[index].selected
                }
            } else if (this.type === this.Constants.USER_WORKER) {
                if (sign_status.status === 1) {
                    this.con_list[index].selected = !this.con_list[index].selected
                }
            }
            this.computedTotal()
        },

        // 计算支付金额
        computedTotal() {
            let total = 0
            let ids = []
            this.con_list.forEach(item => {
                if (item.selected) {
                    ids.push(item.id)
                    total += item.seat_fee * 1
                }
            })
            this.total = total
            this.selectIds = ids
        },
        // 支付
        // async paySubmit() {
        paySubmit: debounce(async function() {
            if (!this.userInfo.mobile) {
                return this.$emit(this.Constants.SHOWBINDMOBILEPOPUP, true);
            }

            if (!this.userInfo.is_real_name) {

                this.$dialog.confirm({
                        title: '温馨提示',
                        message: '请先进行实名认证',
                    })
                    .then(() => {
                        this._onPressToNavigate('', 'identify');

                    })
                    .catch(() => {});
                return;
            }

            let {
                selectIds
            } = this
            if (!selectIds.length) {
                return this.Message({
                    title: '请选择需要报名的课期'
                })
            }
            if (this.total > 0) {
                this.showPaymentStyle = true;
            } else {
                this._doSubmitPay();
            }
        }, 300),

        _onSelectPayStyle(action, index) {
            console.log('action, index---->', action, index);
            this.pay_type = action.pay_type;

            this._doSubmitPay();
        },

        async _doSubmitPay() {
            let subject_list = this.con_list.map(item => {
                if (item.selected) {
                    let obj = {
                        stage_con_id: item.id,
                        subject_id: item.subject_id,
                        job: 0
                    }
                    return obj
                }
            });

            let url = this.API.do_enroll;
            let data = {
                subject_list,
                type: this.type,
                pay_type: this.pay_type,
                return_url: this.return_url,
                return_path: this.return_path,
                subject_stage_id: this.stage_id,
            };
            let result = await this.$post(url, data);
            this.showPaymentStyle = false;
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let {
                    need_pay,
                    pay_config
                } = result.data;
                if (need_pay > 0) {

                    if (this.pay_type == 'alipay') {
                        aliPay(pay_config);
                    } else {
                        if (this.$isWeiXin()) {
                            wxPay(pay_config, (res) => {
                                if (res.type == 'success') {
                                    this._showPayResult();
                                }
                            })
                        } else {
                            this._onPressToWeb(pay_config);
                        }
                    }
                } else {
                    this._showPayResult();
                }
            } else {
                this.ToastManager(result.msg);
            }
        },

        _showPayResult() {
            this.Message({
                type: 5,
                title: '报名成功',
                // content: '请等待平台审核通过',
                btn: ['确认'],
                onClose: (res) => {
                    this._onBack();
                }
            })
        },

        // 报名义工
        signUpSubmit: debounce(async function() {
            if (!this.userInfo.mobile) {
                return this.$emit(this.Constants.SHOWBINDMOBILEPOPUP, true);
            }
            if (!this.userInfo.is_real_name) {

                this.$dialog.confirm({
                        title: '温馨提示',
                        message: '请先进行实名认证',
                    })
                    .then(() => {
                        this._onPressToNavigate('', 'identify');

                    })
                    .catch(() => {});
                return;
            }

            let {
                selectIds
            } = this
            if (!selectIds.length) {
                return this.Message({
                    title: '请选择需要报名的课期'
                })
            }
            let subject_list = this.con_list.map(item => {
                if (item.selected) {
                    let obj = {
                        stage_con_id: item.id,
                        subject_id: item.subject_id,
                        job: item.radio
                    }
                    return obj
                }
            })
            let url = this.API.do_enroll;
            let params = {
                subject_list: subject_list,
                subject_stage_id: this.stage_id,
                type: this.type,
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    type: 5,
                    title: '报名成功',
                    // content: '请等待平台审核通过',
                    btn: ['确认'],
                    onClose: (res) => {
                        this.$router.go(-1)
                    }
                })
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        }, 300),
        // 显示提示
        showPopup() {
            this.show = !this.show
        },

        // 请求数据
        async requestCourseData(subject_id) {
            let url = this.API.subject_detail;
            let params = {
                id: subject_id,
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data
                // this.unlockShowDialog = true
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 解锁开启弹窗
        openDialog() {

            let token = this.Lockr.get('token')
            console.log('token---->', token);
            if (!token) {
                return this.$emit(this.Constants.SHOWLOGINDIALOG, true);
            }

            if (this.dataSources.is_buy != 0) return
            if (this.dataSources.is_ticket == 1) {
                this.show = true
            } else {
                this.$router.push('/contactUs?type=1')
            }
        },
        cancelDialog() {
            this.unlockShowDialog = false
        },
        // 解锁课程
        async onSubmit() {
            let url = this.API.do_ticket;
            let params = {
                id: this.subject_id,
                ticket_no: this.ticket_no,
                secret_key: this.secret_key
            };
            let result = await this.$post(url, params);
            this.ToastManager(result.msg);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.unlockShowDialog = false
            }
        },
        // 跳转
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        },
    },
};
</script>
<style lang="less" scoped>
.header {
    padding: 0 15px;

    img {
        margin-top: 10px;
        height: 140px;
        width: 100%;
        box-sizing: border-box;
        object-fit: cover;
    }

    p {
        margin-top: 10px;
        font-size: 15px;
        color: #333;
        font-weight: 500;
    }
}

.body {
    padding-bottom: 70px;
}

.footer {
    position: fixed;
    left: 15px;
    bottom: 15px;
    width: calc(100% - 30px);
    height: 40px;
    background: linear-gradient(225deg, #9cb2f4, #6472e8);
    font-size: 15px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 3px;

    &.disabled {
        background: linear-gradient(225deg, #ddd, #ccc);
    }

    span {
        font-size: 13px;
    }
}

.van-popup {
    background: transparent;
}

.popup-window {
    width: 229px;
    height: 265px;
    box-sizing: border-box;
    padding-top: 100px;
    background-image: url('../../assets/img/img_showpopup.png');
    background-size: contain;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
        margin-bottom: 5px;
        font-size: 18px;
        color: #7181EB;
        font-weight: 500;
    }

    span {
        margin-bottom: 10px;
        font-size: 15px;
        color: #7181EB;
    }

    div {
        width: 141px;
        height: 33px;
        background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
        border-radius: 3px;
        text-align: center;
        line-height: 33px;
        font-size: 13px;
        color: #fff;
    }
}

.form-box {
    padding: 20px;

    .tips {
        padding: 10px;
        border-radius: 4px;
        background-color: #f6faff;
        display: flex;
        justify-content: center;
        margin-bottom: 10px;

        span {
            font-size: 15px;
            font-weight: 400;
            color: #7181eb;
        }
    }

    /deep/ .van-cell {
        background-color: #f8f8f8;
        margin-bottom: 10px;
        border-radius: 4px;
    }

    /deep/ .van-field__label {
        font-weight: 500;
        width: auto;
    }

    /deep/ .van-field__error-message {
        display: none;
    }

    .btn-box {
        display: flex;
        justify-content: space-around;
        margin-top: 20px;

        /deep/ .van-button {
            width: 100px;
            border-radius: 4px;
            font-size: 15px;
        }
    }
}
</style>